// controllers
import { ProductController } from "controllers";
import { useEffect, useState } from "react";

// components
import { ObjectTagsInput } from "shared/components/bulma/tags-input";

// redux
import { useSelector } from 'react-redux';
import { selectCountry } from '../../../../hyc-store/reducers/countries/countriesReducer';

/**
 * Temp solution till we refactor product.js
 * @param {*} status 
 * @returns 
 */
const getFunctionByStatus = (status) => {
    switch (status) {
        case 'available':
            return ProductController.getAvailableProductByFieldQuery
        default:
            return ProductController.getProductByFieldQuery
    };
}

const ProductSearchInput = ({ status, value, ...props }) => {
    const TAG_KEY_TEXT = 'tagLabel';
    const TAG_KEY_VALUE = 'barcode';

    const country = useSelector(selectCountry);

    const options = { maxTags: 1 };

    const [initialProduct, setInitialProduct] = useState();

    const data = async (search) => {
        let products = [];
        if (search !== "" && search.length > 1) {
            products = await getFunctionByStatus(status)('barcode', search, 10, country);
        }

        for (const product of products) {
            product[TAG_KEY_TEXT] = `${product.barcode} - ${product.name}`;
        }

        return products;
    }

    useEffect(() => {
        const getInitialProduct = async () => {
            if (!value) {
                return;
            }

            const product = await ProductController.getProductByBarcode(value);
            if (product) {
                product[TAG_KEY_TEXT] = `${product.barcode} - ${product.name}`;
                setInitialProduct(product)
            }
        }

        if (value !== initialProduct?.barcode) {
            getInitialProduct();
        }
    });

    return (
        <ObjectTagsInput {...props}
            data={data} options={options}
            value={initialProduct}
            itemText={TAG_KEY_TEXT} itemValue={TAG_KEY_VALUE} />
    );
}

export { ProductSearchInput };
